import dayjs from 'dayjs';

/**
 * Utilities for serializing and deserializing filter values for URL query parameters
 */
export const UrlFilterSerializer = {
    /**
     * Serialize date to YYYY-MM-DD format for URL
     * @param date - Date string or null
     * @returns Formatted date string or undefined if invalid/null
     */
    serializeDate(date: string | null): string | undefined {
        if (!date) return undefined;
        const parsed = dayjs(date);
        return parsed.isValid() ? parsed.format('YYYY-MM-DD') : undefined;
    },

    /**
     * Deserialize YYYY-MM-DD from URL to date string
     * @param dateStr - Date string from URL query parameter
     * @returns Validated date string or null if invalid
     */
    deserializeDate(dateStr: string): string | null {
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateRegex.test(dateStr)) return null;
        const parsed = dayjs(dateStr);
        return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
    }
};
